import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSessionId } from "../../../../../../utils/tokenHandlers";
import { sendESignKp } from "../../apis/sendESignKp";

export const sendESignKpAction = createAsyncThunk(
  "sendESignKpAction",
  async (kpId: number | undefined) => {
    return sendESignKp(kpId, getSessionId()).then((response: any) => {
      return response.data;
    });
  }
);
